import classNames from 'classnames';
import FJQuickSelectionStar from '../../../assets/svg/quick-selection-star.svg?react';
import FJChooseObject from '../../../assets/svg/object-remove-choose.svg?react';
import FJCancelIcon from '../../../assets/svg/cancel.svg?react';
import FJInfoIcon from '../../../assets/svg/info-2.svg?react';
import FJHoverBoardGradation from '../FJHoverBoard/FJHoverBoardGradation';
import FJSwitchButton from '../FJSwitchButton/FJSwitchButton';
import styles from './FJQuickSelectionBox.module.less';
import PropTypes from 'prop-types';
import FJLocalStore from '../../../store/FJLocalStore';
import { useState, useEffect, useRef } from 'react';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';
import FJEvent from '../../../store/FJEvent.js';

const FJQuickSelectionBox = props => {
    const {
        quickSelectionActive,
        changeQuickSelectionActive,
        quickSelectionSelect,
        isDisabled,
        selectQuickSelection,

        tipsTitle,
        tipsText,
        tipsPreviewImg,
        tipsPreviewVideo,
    } = props;

    const [isShowTip, setIsShowTip] = useState(false);
    const [isShowVideo, setIsShowVideo] = useState(false);
    const tipRef = useRef(null);

    const infoClick = () => {
        setIsShowTip(!isShowTip);
    };

    useEffect(() => {
        const isFirstVisit = !localStorage.getItem('hasVisitedBefore');
        if (isFirstVisit) {
            localStorage.setItem('hasVisitedBefore', 'true');
            setIsShowTip(true);
        }
        const handleMouseDown = event => {
            if (tipRef.current && tipRef.current.contains(event.target)) {
                return;
            }
            setIsShowTip(false);
        };

        FJEvent.subscribe(FJ_EVENT_TYPE.HIDE_QUICK_SELECTION_BOX, () => {
            setIsShowTip(false);
        });

        window.addEventListener('mousedown', handleMouseDown);

        return () => {
            window.removeEventListener('mousedown', handleMouseDown);
        };
    }, []);

    return (
        <>
            <div
                className={classNames(
                    styles.quick_selection_box,
                    { [styles.quick_selection_box_active]: quickSelectionActive },
                    { [styles.disabled]: isDisabled },
                )}
            >
                <div className={styles.quick_selection_switch_box}>
                    <div className={styles.quick_selection_text}>
                        {FJLocalStore._('auto-selection')}{' '}
                        <FJQuickSelectionStar className={styles.quick_selection_star} />
                    </div>
                    <div className={styles.quick_selection_switch_box_right}>
                        <div className={styles.quick_selection_info_box} onClick={infoClick}>
                            <FJInfoIcon className={styles.quick_selection_info_icon} />
                        </div>
                        <FJSwitchButton
                            active={quickSelectionActive}
                            onChange={changeQuickSelectionActive}
                            type='gradient'
                        />
                    </div>
                </div>
                <FJHoverBoardGradation
                    className={classNames(styles.quick_selection, {
                        [styles.quick_selection_hover]: !quickSelectionSelect,
                        [styles.quick_selection_active]: quickSelectionSelect,
                    })}
                    contentClassName={styles.quick_selection_content}
                    active={quickSelectionSelect}
                    onClick={selectQuickSelection}
                >
                    <FJChooseObject className={styles.choose_object_icon} />
                    {FJLocalStore._('choose-object')}
                </FJHoverBoardGradation>
            </div>

            <div className={classNames(styles.quick_selection_tip_box, isShowTip && styles.tips_show)} ref={tipRef}>
                <div className={styles.quick_selection_tip_title}>{FJLocalStore._(tipsTitle)}</div>
                <div className={styles.quick_selection_tip_text}>{FJLocalStore._(tipsText)}</div>
                <div className={styles.quick_selection_tip_preview}>
                    <img src={tipsPreviewImg} className={classNames({ [styles.opacity_0]: isShowVideo })} />
                    <video
                        className={classNames({ [styles.opacity_0]: !isShowVideo })}
                        src={tipsPreviewVideo}
                        autoPlay
                        muted
                        loop
                        onCanPlayThrough={() => setIsShowVideo(true)}
                    />
                </div>

                <div className={styles.quick_selection_tip_close} onClick={() => setIsShowTip(false)}>
                    <FJCancelIcon />
                </div>
            </div>
        </>
    );
};

FJQuickSelectionBox.propTypes = {
    quickSelectionActive: PropTypes.bool,
    changeQuickSelectionActive: PropTypes.func,
    quickSelectionSelect: PropTypes.bool,
    isDisabled: PropTypes.bool,
    selectQuickSelection: PropTypes.func,
};

export default FJQuickSelectionBox;
